module.exports = __webpack_public_path__ + "img/img-5d75e9.png";